// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","Coconut":"#F4F7FA","section":"NavigationSections_section__5JZVk"};